module.exports = __webpack_public_path__ + "static/media/YB5F15_0.eef0f4e6.jpg";